import { render, staticRenderFns } from "./ArtistTracks.vue?vue&type=template&id=0332c2fc&scoped=true"
import script from "./ArtistTracks.vue?vue&type=script&lang=js"
export * from "./ArtistTracks.vue?vue&type=script&lang=js"
import style0 from "./ArtistTracks.vue?vue&type=style&index=0&id=0332c2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0332c2fc",
  null
  
)

export default component.exports